// Always include common JS to page-specific
import '/js/common/index';

import 'node-snackbar';

import {
    initCatalogFilters,
    initSelectedFilters,
    initCatalogFiltersModal,
    initSortAndPaging
} from "../common/catalog-filters";
import { ready } from '../utils/ready';
import { initGiftsSpecificButtons } from './functions';

ready(function () {
  if (window.isMobileBackend) {
      initSelectedFilters();
      initCatalogFiltersModal();
  } else {
      initCatalogFilters();
  }
  initSortAndPaging();
  initGiftsSpecificButtons();
});